import React from "react";
import ReactDOM from "react-dom";
import './styles.css';
import PrivateProjectLandingPage from "./pages/PrivateProjectLandingPage";
import { Switch, Route, Link } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';
import Privacy_Healthdata_policy from './pages/Privacy_Healthdata_policy';
import Terms_conditions from './pages/Terms_conditions';
import Our_expertise from './Landingpagecomponents/NavLink/Our_expertise';
import FAQ from './pages/FAQ';
import About from './pages/About';
import Footer from "./Landingpagecomponents/Footer/Footer"
import { Grid, Typography } from "@material-ui/core";
import { createStore, combineReducers, applyMiddleware } from "redux"
import { Provider } from "react-redux"
import ReducThunk from "redux-thunk"
import authRecucer from "./store/reducers/auth"
import Myaccount from "./dashboard/user_dashboard/my_account"
import Physiotherapeutic_plan from "./dashboard/user_dashboard/Physiotherapeutic_plan";
import Learn_about_pain from "./dashboard/user_dashboard/Learn_about_pain";
import Overview from "./dashboard/user_dashboard/Overview";
import PatientFeedback from "./dashboard/user_dashboard/patient_feedback";
import PatientAppointments from "./dashboard/user_dashboard/PatientAppointments";
import PatientMessages from "./dashboard/user_dashboard/patient_messages";
import Assessment from "./Assessment/questionaire";
import virtual_consultation from "./Assessment/embeddedQuestionaire";
import PublicFlowEntry from "./Landingpagecomponents/Content/PublicFlowEntry";
import PublicProviderMatch from "./Landingpagecomponents/Content/PublicProviderMatch";
import PublicProviderBooking from "./Landingpagecomponents/Content/PublicProviderBooking";
import FollowUpAssessment from "./Assessment/questionaire_follow_up";
import FollowUpAssessment_questionaire from "./Assessment/embeddedQuestionaire_follow_up";
import viewRecoveryPhases from "./dashboard/user_dashboard/viewRecoveryPhases";
import HowToGetStarted from "./pages/HowToGetStarted";
import ExerciseMediaUploadPage from "./pages/ExerciseMediaUploadPage";
import PortalPendingActivation from "./pages/PortalPendingActivation";
import Verify_user from "./pages/verify_user";
import ResetPassword from "./pages/ResetPassword";
import AdminDashboard from "./dashboard/admin_dashboard/mainPatientOverview";
import ProgramBuilder from "./dashboard/admin_dashboard/singlePatientOverviewFolder/programBuilder";
import MyClinicAccount from "./dashboard/admin_dashboard/clinicAccount";
import ClinicCalendar from "./dashboard/admin_dashboard/Calendar/calendarParent";
import BillingDashboard from './dashboard/admin_dashboard/BillingDashboard';
import { ProtectedRoute } from "./protected_route";
import Superuser_adminDashboard from "./dashboard/Superuser_admin/mainAdminOverview";
import StripeOnboardingReturn from "./pages/StripeOnboardingReturn";

const rootReducer = combineReducers({
  auth: authRecucer
});

const store = createStore(rootReducer, applyMiddleware(ReducThunk));


class App extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Provider store={store}>
        <div>
          <BrowserRouter> 
            <Switch>
                <Route path="/" exact component={PrivateProjectLandingPage} />
              <Route path="/assessment" component={Assessment} />
              <Route path="/virtual_consultation" component={virtual_consultation} />
              <Route path="/public/start" component={PublicFlowEntry} />
              <Route path="/public/match" component={PublicProviderMatch} />
              <Route path="/public/booking" component={PublicProviderBooking} />
              <Route path="/follow-up-invite" render={(routeProps) => <FollowUpAssessment {...routeProps} showShell={false} />} />
              <ProtectedRoute path="/FollowUpAssessment" component={FollowUpAssessment} />
              <ProtectedRoute path="/FollowUpAssessment_questionaire" component={FollowUpAssessment_questionaire} />
              <Route path="/About" component={About} />
              <Route path="/FAQ" component={FAQ} />
              <Route path="/Our_expertise" component={Our_expertise} />
              <Route path="/Privacy_Healthdata_policy" component={Privacy_Healthdata_policy} />
              <Route path="/Terms_conditions" component={Terms_conditions} />
              <ProtectedRoute path="/myaccount" exact component={Myaccount} />
              <ProtectedRoute path="/physiotherapeutic_plan" exact component={Physiotherapeutic_plan} />
              <ProtectedRoute path="/recovery_phases" exact component={viewRecoveryPhases} />
              <ProtectedRoute path="/overview_of_journey" exact component={Overview} />
              <ProtectedRoute path="/patient_feedback" exact component={PatientFeedback} />
              <ProtectedRoute path="/learn_about_your_pain" exact component={Learn_about_pain} />
              <ProtectedRoute path="/patient_messages" exact component={PatientMessages} />
              <ProtectedRoute path="/my_appointments" exact component={PatientAppointments} />
              <ProtectedRoute path="/portal_pending_activation" exact component={PortalPendingActivation} />
              <Route path="/how_to_get_started" exact component={HowToGetStarted} />
              <Route path="/exercise-media-upload/:token" exact component={ExerciseMediaUploadPage} />
              <ProtectedRoute path="/admin_dashboard" exact component={AdminDashboard} />
              <ProtectedRoute path="/my_clinic_account" exact component={MyClinicAccount} />
              <ProtectedRoute path="/billing" component={BillingDashboard} />
              <ProtectedRoute path="/clinic_calendar" exact component={ClinicCalendar} />
              <ProtectedRoute path="/superuser_admin_dashboard" exact component={Superuser_adminDashboard} />
              {/*<Route path="/superuser_admin_dashboard" exact component={Superuser_adminDashboard} />*/}
              {/* <Route path="/program_builder" exact component={ProgramBuilder} /> */}
              <Route path="/verify_user/:encryptedUserId" exact component={Verify_user} />
              <Route path="/reset_password/:resetToken" exact component={ResetPassword} />
              <Route path="/stripe-onboarding-return" exact component={StripeOnboardingReturn} />
            </Switch>
          </BrowserRouter>
          <Grid xs={0} md={2} lg={1} container style={{ backgroundColor: "dce4eb" }} />
          <Grid xs={0} md={2} lg={1} container style={{ backgroundColor: "dce4eb" }} />
        </div>
      </Provider>
    );
  }
}

export default App;
const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);

//Overvejer at tilføje About og Contact page, men vil måske egentlig bare køre det hele på en landingpage..

//export default function App() {
//  return(
 //   <div className={classes.container}>
 //     {/* <Header /> */}
 //     <Switch>
 //       <Route exact from="/" render={props => <Home {...props} />}  />
 //       <Route exact path="/contact" render={props => <Contact {...props} />} />
 //       <Route exact path="/about" render={props => <About {...props} />} />
//      </Switch>
//    </div>
//  );
//}



//import { Route, Switch } from "react-router-dom";

//const useStyles = makeStyles(Theme => ({
//  root: {
//      minHeight: '100vh',
//      backgroundImage: `url(${Vectorart2})`,
//      backgroundRepeat: "no-repeat",
//      backgroundSize: 'cover',
//  },
//}),